import {useState} from "react";
import {useTranslation} from "react-i18next";
import {FormSessionTranslKey} from "./FormSessionTranslKey";
import {FormSessionDto} from "../../client/formsession/FormSessionApiClient";
import {DetailActionButton} from "../../common/button/CommonActionButtons";
import FormSessionDetailDialog from "./FormSessionDetailDialog";
import {getUniqueId, RowId} from "./FormSessionId";
import Page from "../../common/page/Page";
import FormSessionSearchPanel from "./search/FormSessionSearchPanel";

export function FormSessionPage() {
    const [selectedFormSession, setSelectedFormSession] = useState<FormSessionDto>();
    const {t} = useTranslation();

    const [detailDialogOpen, setDetailDialogOpen] = useState(false);
    const [detailFormSessionId, setDetailFormSessionId] = useState<RowId>();

    function showDetailDialog(formSessionId?: RowId) {
        setDetailFormSessionId(formSessionId);
        setDetailDialogOpen(true);
    }

    function onDetailDialogClose() {
        setDetailDialogOpen(false)
    }

    function onFormSessionSelected(formSession?: FormSessionDto) {
        setSelectedFormSession(formSession);
    }

    const actions: React.ReactNode = (
        <>
            <DetailActionButton
                onClick={() => showDetailDialog(selectedFormSession ? getUniqueId(selectedFormSession) : undefined)}
                disabled={!selectedFormSession}/>
        </>
    );

    return (
        <>
            <Page title={t(FormSessionTranslKey.FORM_SESSIONS_OVERVIEW)}>
                <FormSessionSearchPanel actions={actions}
                                        onSelectedFormSession={onFormSessionSelected}
                                        onFormSessionDoubleClick={showDetailDialog}/>
            </Page>
            <FormSessionDetailDialog open={detailDialogOpen} formSessionId={detailFormSessionId}
                                     onClose={onDetailDialogClose}/>
        </>
    );
}
